import { UserPlus, Mail, Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <UserPlus className="h-12 w-12 text-blue-600" />,
      title: t('landing.howItWorks.steps.signup.title'),
      description: t('landing.howItWorks.steps.signup.description')
    },
    {
      icon: <Mail className="h-12 w-12 text-blue-600" />,
      title: t('landing.howItWorks.steps.createAlias.title'),
      description: t('landing.howItWorks.steps.createAlias.description')
    },
    {
      icon: <Settings className="h-12 w-12 text-blue-600" />,
      title: t('landing.howItWorks.steps.manage.title'),
      description: t('landing.howItWorks.steps.manage.description')
    }
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('landing.howItWorks.title')}
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            {t('landing.howItWorks.subtitle')}
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/3 left-0 right-0 h-0.5 bg-blue-200 z-0"></div>
          
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center text-center p-6 rounded-xl bg-white shadow-md relative z-10"
            >
              <div className="mb-4 bg-blue-50 p-4 rounded-full">{step.icon}</div>
              <div className="bg-blue-600 text-white text-xl font-bold h-8 w-8 rounded-full flex items-center justify-center mb-4">
                {index + 1}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-700">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;